enum ReplenishResultType {
  Success = 'success',
  Failed = 'failed',
  Cancel = 'cancel',
}

enum ReplenishType {
  Par = 'par',
}

export { ReplenishResultType, ReplenishType };
